import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
  name: "user",
  initialState: { value: null, auth: null, dataIndex: [] },
  reducers: {
    login: (state, { payload }) => {
      state.value = payload;
    },
    logout: (state) => {
      state.value = null;
    },
    setAuth: (state, { payload }) => {
      state.auth = payload;
    },
    setLayout: (state, { payload }) => {
      state.layout = payload;
    },
    setIndexData: (state, { payload }) => {
      state.dataIndex = payload;
    },
  },
});

export const { login, logout, setLayout, setAuth, setIndexData } =
  userSlice.actions;
export default userSlice.reducer;
